import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

const apiUrlPrefix: string = "founders";

export const getFounderInstitutions = async (founderId: number) => {
  return api.get(
    `${apiUrlPrefix}/founder-institutions/${founderId}`
  ) as Promise<number[]>;
};
